// extracted by mini-css-extract-plugin
module.exports = {"lightColor":"#868c98"};